module.exports = __webpack_public_path__ + "img/therapy.6d5c6af.jpg?v=1750755973023";